import React from 'react';
import { motion } from 'framer-motion';

export default function MaintenanceMode({ settings = {} }) {
  
  // Lokales Hintergrundvideo (kein YouTube-Player)
  const videoUrl = settings?.maintenance_video_url && /\.(mp4|webm|mov)(\?|$)/i.test(settings.maintenance_video_url)
    ? settings.maintenance_video_url
    : '/video/hero-landscape.mp4';

  return (
    <div className="fixed inset-0 z-[100] bg-ink overflow-hidden">
      {/* Hintergrundvideo */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        poster="/video/hero-landscape.jpg"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        aria-hidden="true"
      >
        <source src={videoUrl} type="video/mp4" />
      </video>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/70" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-12"
        >
          <img
            src="/logo-mark-white.png"
            alt="Someones Direction"
            className="h-16 md:h-20 w-auto"
          />
        </motion.div>

        {/* Main Text */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="text-center max-w-4xl"
        >
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-white leading-tight">
            HIER ENTSTEHT
            <br />
            <span className="text-yellow">ETWAS NEUES.</span>
          </h1>
          <p className="font-accent text-white/80 text-3xl mt-6">Clear direction. Strong work.</p>
        </motion.div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="absolute bottom-8 left-0 right-0 text-center"
        >
          <p className="text-sm text-white/60">
            © 2026 SOMEONES DIRECTION · Wien. Alle Rechte vorbehalten.
          </p>
        </motion.div>
      </div>

      {/* Corner accents */}
      <div className="absolute top-6 left-6 w-16 h-16 border-l border-t border-foreground/20" />
      <div className="absolute top-6 right-6 w-16 h-16 border-r border-t border-foreground/20" />
      <div className="absolute bottom-6 left-6 w-16 h-16 border-l border-b border-foreground/20" />
      <div className="absolute bottom-6 right-6 w-16 h-16 border-r border-b border-foreground/20" />
    </div>
  );
}
